// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"536":"e624be0e","777":"e624be0e"}[chunkId] + ".chunk.css";
};